import axios from "axios";

const offExchangeStore = {
    state: {
        depositData: [],
        totalDeposit: 0,
        withdrawData: [],
        totalWithdraw: 0,
        listMetalData: [],
        totalMetalData: 0
    },

    mutation: {
        setDataDeposit(state, payload) {
            state.depositData = payload.body;
            state.totalDeposit = payload.count;
        },

        setDataWithdrawOffexchange(state, payload) {
            state.withdrawData = payload.data;
            state.totalWithdraw = payload.count;
        },

        setDataMetalWithdrawOffexchange(state, payload) {
            state.listMetalData = payload.data;
            state.totalMetalData = payload.count;
        }
    },
    actions: {
        // getListDeposit({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get("v2/clearing/admin/abx/get/list/deposit", {
        //                 params: {
        //                     serial_number: "",
        //                     type: "",
        //                     limit: "",
        //                     offset: "",
        //                     owner: "",
        //                     startDate: "",
        //                     endDate: "",
        //                     status: "",
        //                 },
        //             })
        //             .then((res) => {
        //                 commit("setDataDeposit", res.data.data);
        //                 resolve(res.data.data);
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             });
        //     });
        // },

        getListOffExchangeWithdraw({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("v2/clearing/admin/abx/offexchange/get/list/withdrawal", {
                        params: {
                            limit: "",
                            offset: "",
                        },
                    })
                    .then((res) => {
                        commit("setDataWithdrawOffexchange", res.data.data);
                        console.log("DATAA" + JSON.stringify(res.data.data))
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getListMetalOffExchangeWithdraw({ commit }, {owner}) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/v2/clearing/admin/abx/get/list/metal", {
                        params: {
                            owner: owner,
                            activity: "deposit",
                            type: "offexchange",
                            status:  ["004","005"],
                            showActiveMetal: true
                        },
                    })
                    .then((res) => {
                        commit("setDataMetalWithdrawOffexchange", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};

export default offExchangeStore;
